const TURBOPACK_CHUNK_LOAD_MESSAGE = 'Failed to load chunk /_next/static/chunks/';

type TurbopackChunkLoadFrame = {
  file?: string;
};

type TurbopackChunkLoadError = {
  errorMessage?: string;
  stacktrace?: TurbopackChunkLoadFrame[];
};

export type TurbopackChunkLoadEvent = {
  errors: TurbopackChunkLoadError[];
};

// Safe to drop: the page the user is on already loaded. Next prefetches another
// route's chunk in the background, and the browser aborted that script (navigation
// or a blip). The file is still on the CDN under ?dpl=. Turbopack also bakes the
// deployment id into the minified runtime, so each production deploy is a new
// Bugsnag group and dashboard Ignore does not carry over.
//
// Match the message only. onError sees the raw browser stack, whose file is the
// minified chunk URL. Bugsnag applies source maps after the event is sent, so
// runtime-base.ts is never present here. This message is thrown only by the
// Turbopack runtime.
export const isTurbopackChunkLoadNoise = (event: TurbopackChunkLoadEvent) =>
  event.errors.some((err) => !!err.errorMessage?.includes(TURBOPACK_CHUNK_LOAD_MESSAGE));
